import { render, staticRenderFns } from "./StaffTypologyCommonFilters.vue?vue&type=template&id=4ffbbb3a&"
import script from "./StaffTypologyCommonFilters.vue?vue&type=script&lang=js&"
export * from "./StaffTypologyCommonFilters.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports